import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import React from 'react';
import HTTPClient from '../../Utils/HTTPClient';

import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import { SETTINGS_ROUTES } from '../../Config/routes';
import Header from '../Includes/Header';
const Branch = (props) => {
  const [braField, setBraField] = React.useState('');
  const [braId, setBraId] = React.useState('');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [braList, setBraList] = React.useState([]);

  const handleBraInput = (e) => {
    setBraField(e.target.value);
  };
  const handleSubmitForm = () => {
    const param = { branch: braField, id: braId };
    HTTPClient.post(SETTINGS_ROUTES.branch.create(), param)
      .then((response) => {
        getBraList();
        handleClearForm();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getBraList = () => {
    HTTPClient.get(SETTINGS_ROUTES.branch.list())
      .then((response) => {
        setBraList(response.data.branchs);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete?')) {
      const param = { id: id };
      HTTPClient.post(SETTINGS_ROUTES.branch.delete(), param)
        .then((response) => {
          getBraList();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleEdit = (id) => {
    HTTPClient.get(SETTINGS_ROUTES.branch.get(id))
      .then((response) => {
        if (response.data.branch) {
          setBraField(response.data.branch.branch);
          setBraId(response.data.branch.id);
          setOpenDialog(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClearForm = () => {
    setBraField('');
    setBraId('');
    setOpenDialog(false);
  };
  React.useEffect(() => {
    getBraList();
  }, []);
  return (
    <React.Fragment>
      <Header />
      {openDialog ? (
        <Dialog open={openDialog} onClose={handleClearForm}>
          <DialogActions disableSpacing={true}>
            <IconButton
              className="close-pos close-span"
              onClick={(e) => {
                handleClearForm(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
          <DialogContent>
            <h4 className={'sethead'}>{braId ? 'Update' : 'Create'} Branch</h4>
            <div style={{ minWidth: 275 }}>
              <p>
                <TextField
                  id="outlined-basic"
                  fullWidth={true}
                  label="Branch"
                  variant="outlined"
                  value={braField}
                  onChange={handleBraInput}
                  type="text"
                />
              </p>
              <Button
                disabled={braField.length == 0}
                onClick={handleSubmitForm}
                variant="contained"
              >
                {braId ? 'Update' : 'Create'}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      ) : null}
      <Container maxWidth="md" className="settings-container">
        <Grid container>
          <Grid item sm={8}>
            <h2 className={'filterhead'}>Branch List</h2>
          </Grid>
          <Grid item sm={4} style={{ textAlign: 'right' }}>
            <Button
              variant="outlined"
              className="settingsnbtn"
              onClick={(e) => setOpenDialog(true)}
            >
              Add Branch
            </Button>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" className={'sett-table'}>
            <TableHead>
              <TableRow>
                <TableCell padding={'none'}>Name</TableCell>
                <TableCell align="right" padding={'none'}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {braList.map((row) => (
                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell padding={'none'}>{row.branch}</TableCell>
                  <TableCell padding={'none'} align="right">
                    <IconButton onClick={(e) => handleEdit(row.id)} aria-label="edit">
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={(e) => handleDelete(row.id)} aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </React.Fragment>
  );
};

export default Branch;
